import { FunctionComponent, useCallback, useContext, useEffect, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import InfiniteScroll from 'react-infinite-scroll-component';
import { FeedCard, PostedIn } from '../../components';
import { UserContext } from '../../context';
import { FeedCardLoader, useAppDispatch, useAppSelector } from '../../shared';
import { getStoryCardsBookmarksFeed, loadMoreStoryCardsBookmarksFeed } from '../../slices';
import { NoContent } from '../Error';

import classes from './BookmarksFeed.module.scss';

export const BookmarksFeed: FunctionComponent = () => {
  const { t } = useTranslation();

  const dispatch = useAppDispatch();

  const { storyCardsBookmarksFeed, page, hasNextPage, isFetched } = useAppSelector(
    ({ storyCardsBookmarksFeed }) => storyCardsBookmarksFeed
  );

  const { userInfo, userProfile } = useContext(UserContext);

  const { channelId } = userInfo.userData;

  const { isAnonymous } = userProfile;

  useEffect(() => {
    if (isAnonymous) {
      return;
    }

    dispatch(getStoryCardsBookmarksFeed({ channelId }));
  }, [channelId, dispatch, isAnonymous]);

  const loadMore = useCallback(() => {
    dispatch(loadMoreStoryCardsBookmarksFeed({ channelId, page: page + 1 }));
  }, [channelId, dispatch, page]);

  const dataLength = useMemo(
    () => storyCardsBookmarksFeed.length,
    [storyCardsBookmarksFeed.length]
  );

  if (isAnonymous) {
    return <NoContent />;
  }

  if (!isFetched) {
    return <FeedCardLoader />;
  }

  if (!dataLength) {
    return <NoContent subtitle={t('bookmarks.no-content-subtitle')} />;
  }

  return (
    <>
      <h1 className={classes['title']}>{t('secondaryTabs.bookmarks')}</h1>
      <InfiniteScroll
        next={loadMore}
        hasMore={hasNextPage}
        dataLength={dataLength}
        loader={<FeedCardLoader />}
        className={classes['bookmarks-feed']}
      >
        <div className={classes['bookmarks-feed__items']}>
          {storyCardsBookmarksFeed.map((card, index, storyCardsBookmarksFeedArray) => {
            return (
              <div key={card.id}>
                {card.story.id !== storyCardsBookmarksFeedArray[index - 1]?.story.id && (
                  <PostedIn story={card.story} />
                )}
                <FeedCard card={card} />
              </div>
            );
          })}
        </div>
      </InfiniteScroll>
    </>
  );
};
